import { useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { MultiColumn, MultiColumnGroup, MultiColumnItem } from 'foundations-components/transitional/components/MultiColumn';
import { Button } from 'foundations-components/transitional/components/Button';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { isAllowedToLeaveBeta } from '../utils/enrollmentStatus';
import { PRIVATE_BETA, PUBLIC_BETA } from '../../RolloutTypes';
import EditBetaDialog from '../EnrollmentButtonDialogs/EditBetaDialog';
import { useAuthState } from '../../../app/hooks/useAuthState';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RolloutProductUpdateDetailsPanelBetaInfo = props => {
  const {
    rolloutProductUpdate: {
      id,
      rollout: {
        betaPaused,
        id: rolloutId,
        enrollmentStatus,
        enrollType,
        gate
      },
      title,
      untranslatedTitle,
      rolloutState
    }
  } = props;
  const {
    hasBetaAccess
  } = useAuthState();
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const canEditAccess = isAllowedToLeaveBeta(enrollmentStatus) && hasBetaAccess && enrollType === 'USERS_AND_PORTALS' && !betaPaused;
  return /*#__PURE__*/_jsx(MultiColumn, {
    marginBlock: "300",
    children: /*#__PURE__*/_jsxs(MultiColumnGroup, {
      children: [/*#__PURE__*/_jsx(MultiColumnItem, {
        children: /*#__PURE__*/_jsx("b", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `app.detailsPanel.betaSection.${rolloutState}.${enrollmentStatus}`
          })
        })
      }), rolloutState === PUBLIC_BETA || rolloutState === PRIVATE_BETA && /*#__PURE__*/_jsxs(MultiColumnItem, {
        width: "30%",
        children: [/*#__PURE__*/_jsx(Tooltip, {
          disabled: canEditAccess,
          title: enrollType !== 'USERS_AND_PORTALS' ? /*#__PURE__*/_jsx(FormattedMessage, {
            message: "app.detailsPanel.editAccessNotSupportedTooltip"
          }) : /*#__PURE__*/_jsx(FormattedMessage, {
            message: "app.detailsPanel.editAccessTooltip"
          }),
          children: /*#__PURE__*/_jsx(Button, {
            disabled: !canEditAccess,
            size: "xs",
            use: "link",
            onClick: () => {
              setEditDialogOpen(true);
            },
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "app.detailsPanel.editAccess"
            })
          })
        }), editDialogOpen && /*#__PURE__*/_jsx(EditBetaDialog, {
          id: id,
          rolloutId: rolloutId,
          betaAccessType: rolloutState === PRIVATE_BETA ? 'PRIVATE' : 'PUBLIC',
          enrollmentStatus: enrollmentStatus,
          enrollType: enrollType,
          title: title,
          untranslatedTitle: untranslatedTitle,
          gate: gate,
          onClose: () => {
            setEditDialogOpen(false);
          }
        })]
      })]
    })
  });
};
export default RolloutProductUpdateDetailsPanelBetaInfo;